export default "__VITE_ASSET__NMEfBkAP__"